import script from "./reset_password.vue?vue&type=script&setup=true&lang=js"
export * from "./reset_password.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__